export const TRELLO_PRODUCT_ID = 'trello';
export let TrelloScope = /*#__PURE__*/function (TrelloScope) {
  TrelloScope["Board"] = "trello.board";
  TrelloScope["Card"] = "trello.card";
  return TrelloScope;
}({});